<template>
  <div id="modalDetailsPlan" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            Detalhes do Plano:
            <span class="text-primary">
              {{ plan.name }} (<small>{{ plan.categoryName }} </small>)
            </span>
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <div class="modal-body pb-0 text-center">
          <div>
            <h6 class="fw-bold mb-1">Descrição</h6>
            <p class="mb-0">{{ plan.description ? plan.description : '-' }}</p>
          </div>
          <hr />
          <div v-if="plan.classification == 1">
            <h6 class="fw-bold">Preços</h6>
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th>Faixa</th>
                  <th>Número de Usuários</th>
                  <th>Valor Mensal</th>
                  <th>Valor Anual</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="price in plan.prices" :key="price.id">
                  <td :title="price.description">
                    {{ price.range }}
                  </td>
                  <td>{{ price.minUser }} a {{ price.maxUser }}</td>
                  <td>{{ moneyToCurrencyBr(price.monthlyPrice) }}</td>
                  <td>{{ moneyToCurrencyBr(price.annualPrice) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="plan.classification == 2">
            <h6 class="fw-bold mb-1">Preço</h6>
            <p class="mb-0">
              Valor Único: {{ moneyToCurrencyBr(plan.valueSinglePayment) }}
            </p>
          </div>
          <hr />
          <div>
            <h6 class="fw-bold">Cursos</h6>
            <div v-if="plan.courses.length > 0">
              <div
                v-for="course in plan.courses"
                :key="course.id"
                class="card border-start border-start-success border-start-width-2"
              >
                <div class="card-body p-2">
                  <h6 class="card-title">{{ course.name }}</h6>
                  <p><strong>Descrição:</strong> {{ course.description }}</p>
                  <p><strong>Instrutor(a):</strong> {{ course.instructor }}</p>
                </div>
              </div>
            </div>
            <p v-else>
              Este plano atualmente não possui nenhum curso associado
            </p>
          </div>
        </div>
        <div class="modal-footer border-top-0 pt-0">
          <button
            type="button"
            class="btn btn-link"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          >
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal } from '@/utils/modal'
import { moneyToCurrencyBr } from '@/utils/strings'

export default {
  name: 'DetailsPlanModal',

  props: {
    plan: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      moneyToCurrencyBr,
    }
  },

  mounted() {
    showModal('modalDetailsPlan')
  },
}
</script>
